
import * as TypeEvaluation from '../TypeEvaluation';

export function getActionCaseTitle(special){
  if (special.s === 'If_Fail'){
    return 'Error Message';
  }else if (special.s === 'Post_Prompt'){
    return 'Response to Prompt';
  }
}

export function getActionCasesFn(overallPath){
  var actionCases = [];
  var canAddAction = -1;
  for (var i = 0; i < overallPath.length; i++){
    var thisItem = overallPath[i];
    if (thisItem === 'oc'){
      canAddAction = +i + 2;
      i ++;
    }else if (canAddAction > -1){
      if (thisItem === 'If_Fail' || thisItem === 'Post_Prompt'){
        actionCases.push({s:thisItem,k:i - canAddAction,tS:{t:'Text String'}})
      }
    }
  }
  return actionCases;
}

export function getType(actionCases, firstNode){
  for (var i5 = 0; i5 < actionCases.length; i5++){
    if (actionCases[i5].k === firstNode.v.k && actionCases[i5].s === firstNode.v.s){
      return TypeEvaluation.walkDownObjPathToGetType(actionCases[i5].tS, firstNode.p);
    }
  }
  return {t:'toDelete'};
}
